/* ==========================================================================
   AutocompleteRxjs > Client > constants
   ========================================================================== */
const CODE_ARROW_DOWN = 40;
const CODE_ARROW_UP = 38;
const CODE_ENTER = 13;
const CODE_ESC = 27;
const CODE_TAB = 9;

/* Exports */
module.exports = {
    APPENDTOPARENT: true,
    GEOLOCATION: false,
    ICONS: {
        AER: 'plane',
        BUS: 'bus',
        CIU: 'building',
        EST: 'train',
        FLIGHTS_COMPANY: 'plane',
        HOT: 'hotel',
        ISL: 'beach',
        PDI: 'marker',
        PUE: 'ferry',
        ZON: 'marker'
    },
    KEY_ARROW_DOWN: CODE_ARROW_DOWN,
    KEY_ARROW_UP: CODE_ARROW_UP,
    KEY_ENTER: CODE_ENTER,
    KEY_ESC: CODE_ESC,
    KEY_TAB: CODE_TAB,
    LIMIT: 120,
    MAX: 20,
    NO_OPEN_SUGGESTIONS_KEYS: [CODE_ENTER, CODE_ESC, CODE_TAB],
    PLACEMENT: 'bottom-start',
    SUGGESTIONS_KEYS: [CODE_ARROW_DOWN, CODE_ARROW_UP, CODE_ENTER, CODE_ESC, CODE_TAB],
    THRESHOLD: 3,
    LOADER_TEMPLATE: '<div class="autocomplete-rxjs__loader" data-loader><div></div></div>'
};
